import { matchPath } from 'react-router'
import { observer, inject } from 'mobx-react'
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import InlineSVG from 'svg-inline-react'
import _ from 'lodash'

import avatar from '../../../assets/icons/AvatarSVG'
import { API_URL } from '../../../api'
import { MobileDrawer } from './sidebar'
import { withRouterProps } from '../../../utils'

const Box = styled.div`
  flex: 0 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: auto;
  border: ${p => p.theme.topNavBorder};
  box-shadow: 0 2px 2px 0 rgba(182, 192, 196, 0.15);
  @media (max-width: 800px) {
    height: 64px;
    justify-content: flex-start;
  }
  background-color: ${p => p.theme.topNavColor};
`
const LogoContainer = styled.div`
  * {
    max-width: 220px;
    min-width: 175px;
  }
  padding: 20px;
  cursor: pointer;
`

const Logo = styled.img`
  width: 100%;
  content: url(${p => API_URL + p.theme.logo});
`

const MenuBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-x: auto;
  @media (max-width: 800px) {
    display: none;
  }
`
const MenuItem = styled.div`
  cursor: pointer;
  padding: 20px;
  white-space: nowrap;
  transition:
    color 0.35s,
    padding 0.35s;
  @media (max-width: 900px) {
    padding: 10px;
  }
  color: ${p => (p.isActive ? p.theme.primaryColor : p.theme.topNavTextColor)};
`
const ProfileBox = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 15px;
  transition: 0.35s;
  color: ${p => (p.isActive ? p.theme.primaryColor : p.theme.topNavTextColor)};
  min-width: 90px;
`
const AvatarBox = styled.div`
  min-width: 28px;
  width: 28px;
  height: 28px;
  padding: 4px;
  & svg {
    transition: 0.35s;
    stroke: ${p => (p.isActive ? p.theme.primaryColor : `#7a8e96`)};
    fill: ${p => (p.isActive ? p.theme.primaryColor : `#7a8e96`)};
  }
`
const Logout = styled.button`
  cursor: pointer;
  min-width: 66px;
  width: 92px;
  height: 47px;
  border: ${p => p.theme.logoutButtonBorder};
  border-radius: 4px;
  background-color: ${p => p.theme.logoutButtonColor};
  margin: 15px;
  color: ${p => (p.isActive ? p.theme.primaryColor : p.theme.topNavTextColor)};
`

const TopNav = props => {
  const location = props.location?.pathname ?? ''
  const {
    navigate,
    store: { features, person, config },
  } = props
  const overallStrategyPaths = ['/overall', '/spending']
  const overallStrategyIsActive = overallStrategyPaths.some(path => matchPath({ path }, location))

  const handleLogout = () => {
    window.open(`${API_URL.slice(0, -4)}logout`, '_self')
  }

  const ensureSideOpen = () => {
    if (!props.main.enableSidebar) props.main.setSidebar(true)
  }

  const onClickHome = () => {
    navigate('/home')
    ensureSideOpen()
  }

  const onClickOverallStrategy = () => {
    navigate('/overall')
    ensureSideOpen()
  }
  const onClickGoals = () => {
    navigate('/goals')
    ensureSideOpen()
  }
  const onClickAccounts = () => {
    navigate('/accounts')
    ensureSideOpen()
  }
  const onClickTools = () => {
    navigate('/tools')
    ensureSideOpen()
  }
  const onClickHelp = () => {
    navigate('/help')
    ensureSideOpen()
  }
  const onClickProfile = () => {
    navigate('/profile')
    ensureSideOpen()
  }

  if (props.main.enableTopNav !== undefined && props.main.enableTopNav === false) {
    return null
  }

  return (
    <Box>
      <MobileDrawer />
      <LogoContainer onClick={onClickHome}>
        <Logo alt='Logo' />
      </LogoContainer>
      <MenuBox>
        {features.enableHomePage && !features.enablePersonalizedTargetDatePlus && (
          <MenuItem isActive={matchPath({ path: '/home' }, location)} onClick={onClickHome}>
            Home
          </MenuItem>
        )}

        {_.includes(
          ['Overall', 'Spending', 'Simplified'],
          config.template.overallPageComponent
        ) && (
          <MenuItem isActive={overallStrategyIsActive} onClick={onClickOverallStrategy}>
            Overall Strategy
          </MenuItem>
        )}

        {features.enableGoals && (
          <MenuItem isActive={matchPath({ path: '/goals' }, location)} onClick={onClickGoals}>
            Goals
          </MenuItem>
        )}

        {features.enableAccounts && (
          <MenuItem isActive={matchPath({ path: '/accounts' }, location)} onClick={onClickAccounts}>
            Accounts
          </MenuItem>
        )}

        {features.enableTools && (
          <MenuItem isActive={matchPath({ path: '/tools' }, location)} onClick={onClickTools}>
            Tools
          </MenuItem>
        )}

        {features.enableHelp && (
          <MenuItem isActive={matchPath({ path: '/help' }, location)} onClick={onClickHelp}>
            Help
          </MenuItem>
        )}

        <ProfileBox isActive={matchPath({ path: '/profile' }, location)} onClick={onClickProfile}>
          <AvatarBox isActive={matchPath({ path: '/profile' }, location)}>
            <InlineSVG src={avatar} element='span' />
          </AvatarBox>
          {features.enablePreferredName ? (
            <span
              css={css`
                text-overflow: ellipsis;
              `}>
              {person.displayName}
            </span>
          ) : (
            <span
              css={css`
                text-overflow: ellipsis;
              `}>
              {_.get(this, 'props.store.account.productId', '') === 5
                ? person.firstName
                : 'Profile'}
            </span>
          )}
        </ProfileBox>

        <Logout onClick={handleLogout}>Logout</Logout>
      </MenuBox>
    </Box>
  )
}

export default withRouterProps(inject('store', 'main')(observer(TopNav)))
